<script setup lang="ts">
import { Head, Link, usePage } from "@inertiajs/vue3";

import SessionListItem from "@/components/session-list-item.vue";
import { Button } from "@/components/ui/button/index";
import SettingsLayout from "@/layouts/settings/layout";
import { sessionPath } from "@/routes";

defineOptions({ inheritAttrs: false });
interface Session {
  id: string;
  user_agent: string;
  ip_address: string;
  created_at: string;
}

interface Props {
  sessions: Session[];
}

const props = defineProps<Props>();
const page = usePage<{ auth?: { session?: { id: string } } }>();
</script>

<template>
  <Head title="Sessions" />

  <main
    class="relative flex h-full min-h-0 w-full flex-col gap-3 bg-muted/50 p-3"
  >
    <SettingsLayout
      current="sessions"
      title="Sessions"
      description="Manage active sessions across devices."
    >
      <div class="space-y-3">
        <SessionListItem
          v-for="session in props.sessions"
          :key="session.id"
          :session="session"
          :current-session-id="page.props.auth?.session?.id"
        >
          <template #action="{ isCurrent }">
            <Button v-if="!isCurrent" variant="destructive" size="sm" as-child>
              <Link
                :href="sessionPath({ id: session.id })"
                method="delete"
                as="button"
              >
                Log out
              </Link>
            </Button>
          </template>
        </SessionListItem>

        <p
          v-if="props.sessions.length === 0"
          class="text-sm text-muted-foreground"
        >
          No sessions found.
        </p>
      </div>
    </SettingsLayout>
  </main>
</template>
